<script>
import { mapMutations, mapState, mapGetters } from 'vuex'
import { required, requiredUnless, minLength, maxLength, numeric } from 'vuelidate/lib/validators'

export default {
  name: 'StudentAddresses',
  props: ['validation'],
  data () {
    return {
    }
  },
  computed: {
    ...mapState('students', {
      billingAddressForm: state => state.billingAddressForm,
      shippingAddressForm: state => state.shippingAddressForm,
      sameAsBilling: state => state.shippingAddressForm.sameAsBilling,
    }),
    ...mapGetters([
      'stateOptions'
    ]),
    ...mapGetters('students', [
      'stateAbbrev'
    ])
  },
  methods: {
    ...mapMutations('students', [
      'updateForm',
      'setSameAsBilling'
    ]),
    onDropdownFocus (index) {
        let dropdown = this.$refs[index]
        dropdown.show()
    }
  }
}

</script>

<template>
  <div class="layout-padding">
    <div class="billing-address" style="margin-bottom:60px">
      <h5> Billing Address </h5>
      <div class="row">
        <q-field class="q-pa-md col-12">
          <q-input
            float-label="Address 1"
            :value="billingAddressForm.ADDRESS_1"
            :disable="true"
            required>
          </q-input>
            <!-- @keyup.stop="updateForm({ form: 'billingAddressForm', field: 'ADDRESS_1', value: $event.target.value })" -->
        </q-field>
      </div>
      <div class="row">
        <q-field class="q-pa-md col-12">
          <q-input
            float-label="Address 2"
            :value="billingAddressForm.ADDRESS_2"
            :disable="true"
            required>
            <!-- @keyup.stop="updateForm({ form: 'billingAddressForm', field: 'ADDRESS_2', value: $event.target.value })" -->
          </q-input>
        </q-field>
      </div>
      <div class="row">
        <q-field class="q-pa-md col-4"
          :error="validation.billingAddressForm.CITY.$error"
            error-label="City required">
          <q-input
            float-label="City"
            :value="billingAddressForm.CITY"
            :disable="true"
            required>
            <!-- @keyup.stop="updateForm({ form: 'billingAddressForm', field: 'CITY', value: $event.target.value })"
            @blur="validation.billingAddressForm.CITY.$touch" -->
          </q-input>
        </q-field>
        <q-field class="q-pa-md col-4"
          :error="validation.billingAddressForm.LK_STATE_ID.$error"
          error-label="State required">
          <q-select
            float-label="State"
            :ref="'billingStateDropdown'"
            :value="billingAddressForm.LK_STATE_ID"
            :disable="true"
            @focus="onDropdownFocus('billingStateDropdown')"
            filter autofocus-filter :options="stateOptions"
          />
            <!-- @change="val => updateForm({ form: 'billingAddressForm', field: 'LK_STATE_ID', value: val })"
            @blur="validation.billingAddressForm.LK_STATE_ID.$touch" -->
        </q-field>
        <q-field class="q-pa-md col-4"
          :error="validation.billingAddressForm.ZIP_CODE.$error"
          error-label="Requires 5 numeric characters">
          <q-input
            float-label="Zip"
            :value="billingAddressForm.ZIP_CODE"
            :disable="true"
            required>
            <!-- @keyup.stop="updateForm({ form: 'billingAddressForm', field: 'ZIP_CODE', value: $event.target.value })"
            @blur="validation.billingAddressForm.ZIP_CODE.$touch" -->
          </q-input>
        </q-field>
      </div>
    </div>
    <div class="shipping-address">
      <h5>Mailing Address <q-checkbox style="margin-left:20px" :disable="true" v-model="shippingAddressForm.sameAsBilling" @input="val => setSameAsBilling({ status: val })"/> <span style="font-size:13px;display:inline-block;vertical-align:middle; margin-left:5px">Same as Billing</span></h5>
      <div v-if="!shippingAddressForm.sameAsBilling">
        <div class="row">
          <q-field class="q-pa-md col-12">
            <q-input
              float-label="Address 1"
              :value="shippingAddressForm.ADDRESS_1"
              :disable="true"
              required>
              <!-- @keyup.stop="updateForm({ form: 'shippingAddressForm', field: 'ADDRESS_1', value: $event.target.value })" -->
            </q-input>
          </q-field>
        </div>
        <div class="row">
          <q-field class="q-pa-md col-12">
            <q-input
              float-label="Address 2"
              :value="shippingAddressForm.ADDRESS_2"
              :disable="true"
              required>
              <!-- @keyup.stop="updateForm({ form: 'shippingAddressForm', field: 'ADDRESS_2', value: $event.target.value })" -->
            </q-input>
          </q-field>
        </div>
        <div class="row">
          <q-field class="q-pa-md col-4"
            :error="validation.shippingAddressForm.CITY.$error"
            error-label="City required">
            <q-input
              float-label="City"
              :value="shippingAddressForm.CITY"
              :disable="true"
              required>
              <!-- @keyup.stop="updateForm({ form: 'shippingAddressForm', field: 'CITY', value: $event.target.value })"
              @blur="validation.shippingAddressForm.CITY.$touch" -->
            </q-input>
          </q-field>
          <q-field class="q-pa-md col-4"
            :error="validation.shippingAddressForm.LK_STATE_ID.$error"
            error-label="State required">
            <q-select
              float-label="State"
              :ref="'shippingStateDropdown'"
              :value="shippingAddressForm.LK_STATE_ID"
              filter autofocus-filter :options="stateOptions"
              :disable="true"
            />
              <!--@change="val => updateForm({ form: 'shippingAddressForm', field: 'LK_STATE_ID', value: val })"
              @focus="onDropdownFocus('shippingStateDropdown')"
              @blur="validation.shippingAddressForm.LK_STATE_ID.$touch"-->
          </q-field>
          <q-field class="q-pa-md col-4"
            :error="validation.shippingAddressForm.ZIP_CODE.$error"
            error-label="Requires 5 numeric characters">
            <q-input
              float-label="Zip"
              :value="shippingAddressForm.ZIP_CODE"
              :disable="true"
              required>
              <!--@keyup.stop="updateForm({ form: 'shippingAddressForm', field: 'ZIP_CODE', value: $event.target.value })"
              @blur="validation.shippingAddressForm.ZIP_CODE.$touch"-->
            </q-input>
          </q-field>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="stylus">
  .q-tabs-panes {
    display: flex;
    // overflow: scroll;
    // max-width: 1400px;
    // margin: auto;
  }
  .sl-row.sl-abs
      height calc(100% - 110px)
</style>
